import script from "./paymentTest.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentTest.vue?vue&type=script&setup=true&lang=js"

import "./paymentTest.vue?vue&type=style&index=0&id=2a822eae&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a822eae"]])

export default __exports__